import React from 'react';
import authRoles from 'app/auth/authRoles';
import CompanyListing from './CompanyListing';
import SchoolDetail from './SchoolDetail';
import ViewCompany from './ViewCompany';
import AddCompany from './AddCompany';
import EditCompany from './EditCompany';
import AddSchool from './AddSchool';
import EditSchool from './EditSchool';

const CompanyConfig = {
	settings: {
		layout: {
			config: {},
		},
	},
	routes: [
		{
			path: '/company',
			element: (
				<React.Suspense fallback={<>...</>}>
					<CompanyListing />
				</React.Suspense>
			),
		},
		{
			path: '/schoolDetail/:id',
			element: (
				<React.Suspense fallback={<>...</>}>
					<SchoolDetail />
				</React.Suspense>
			),
		},
		{
			path: '/viewCompany/:id',
			element: (
				<React.Suspense fallback={<>...</>}>
					<ViewCompany />
				</React.Suspense>
			),
		},
		{
			path: '/addCompany',
			element: (
				<React.Suspense fallback={<>...</>}>
					<AddCompany />
				</React.Suspense>
			),
		},
		{
			path: '/editCompany/:id',
			element: (
				<React.Suspense fallback={<>...</>}>
					<EditCompany />
				</React.Suspense>
			),
		},
		{
			path: '/addSchool/:id',
			element: (
				<React.Suspense fallback={<>...</>}>
					<AddSchool />
				</React.Suspense>
			),
		},
		{
			path: '/EditSchool/:id',
			element: (
				<React.Suspense fallback={<>...</>}>
					<EditSchool />
				</React.Suspense>
			),
		},
	],
	auth: authRoles.productOwner,
};

export default CompanyConfig;
